// Screen 2 (spec 13 §Screens): the operator console. The week lives in the URL (`?p=`), the
// same key the company screens use for the focused period.
import { createRoute, useNavigate } from "@tanstack/react-router";
import { isOperator } from "../features/company";
import { OperatorConsole } from "../features/operator/operator-console";
import { useSession } from "../features/use-feature";
import { validateFocusSearch } from "../focus/focus";
import { currentWeek } from "../focus/weeks";
import { NoAccessPage } from "../pages/status-pages";
import { OperatorShell, PlainShell } from "../shell/app-shell";
import { authedRoute } from "./_authed";

export const operatorRoute = createRoute({
  getParentRoute: () => authedRoute,
  path: "operator",
  validateSearch: (search: Record<string, unknown>): { p?: string } => {
    const { p } = validateFocusSearch(search);
    return p ? { p } : {};
  },
  component: OperatorScreen,
});

function OperatorScreen() {
  const { api } = operatorRoute.useRouteContext();
  const { p } = operatorRoute.useSearch();
  const navigate = useNavigate();
  const { me } = useSession();
  if (!isOperator(me)) {
    return (
      <PlainShell me={me} api={api} current={null}>
        <NoAccessPage what="The operator console" />
      </PlainShell>
    );
  }
  return (
    <OperatorShell me={me} api={api}>
      <OperatorConsole
        api={api}
        me={me}
        week={p ?? currentWeek()}
        onWeek={(week) => void navigate({ to: "/operator", search: { p: week } })}
      />
    </OperatorShell>
  );
}
